import { render, staticRenderFns } from "./ninePage.vue?vue&type=template&id=7f719f57&"
import script from "./ninePage.vue?vue&type=script&lang=js&"
export * from "./ninePage.vue?vue&type=script&lang=js&"
import style0 from "./ninePage.vue?vue&type=style&index=0&id=7f719f57&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports